import { createApp, onBeforeUnmount, onMounted } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import './assets/css/common.css'
import './assets/css/bootstrap.min.css'
import autofit from 'autofit.js'
// onMounted(() => {
//   autofit.init(
//     {
//       dh: 1080,
//       dw: 1920,
//       el: '#app',
//       resize: true
//     },
//     false
//   )
// })
// onBeforeUnmount(() => {
//   autofit.off()
// })

createApp(App).use(store).use(router).use(Antd).mount('#app')
